import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'md' | 'lg';
};
const sizes = {
  md: 'px-5 py-3 text-sm',
  lg: 'px-6 py-4 text-sm md:px-10 md:py-5 md:text-lg'
};
export function Button({
  children,
  href,
  subtext,
  className = '',
  fullWidth,
  size = 'md'
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex flex-col items-center justify-center rounded-xl border-2 border-b-[6px] border-gold-dark bg-gold text-center font-black uppercase tracking-wide text-brand-deep shadow-xl shadow-brand-deep/30 transition-colors duration-150 ease-out hover:bg-gold-light focus:outline-none focus:ring-4 focus:ring-gold-light/70 ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-237" data-mp="1sizticizjs81">
      <span className="flex items-center gap-2" data-id="element-238" data-mp="er7gdptes2b6">
        {children}
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-239" data-mp="tn6v3jb0x0pa" />
      </span>
      {subtext && <span className="mt-1 text-[11px] font-semibold normal-case tracking-normal text-brand-deep/80 md:text-xs" data-id="element-240" data-mp="omsm9z1llmq7">
          {subtext}
        </span>}
    </motion.a>;
}